import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class BomManagerRoute extends AuthenticatedRoute {}
